import { getTournamentLeaderboard } from 'services/games';
import DataTablePage from 'components/DataTablePage';
import leaderboardColumnData from 'data/leaderboardColumnData';

function Tournament() {
  let tournamentId = window.location.pathname.split('/').pop();

  return (
    <>
      <DataTablePage
        title='Leaderboard Entries'
        canSearch
        canFilter
        fetchData={() => getTournamentLeaderboard(tournamentId)}
        queryKey='leaderboard'
        columnData={leaderboardColumnData}
        object={'leaderboard'}
        noActions={true}
      />
      {/* <DashboardLayout>
        <DashboardNavbar />
        <MDBox px={2}>
          <MDTypography sx={{ fontWeight: 600 }}>Tournament Leaderboard Entries</MDTypography>
        </MDBox>
        <MDBox sx={{ width: '100%', display: 'flex', flexDirection: 'column', gap: '24px' }} px={2} py={4}>
          {tournament.length > 0 &&
            tournament?.map((entry) => {
              const date = new Date(entry.createdAt);

              const day = String(date.getUTCDate()).padStart(2, '0');
              const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Months are 0-based
              const year = date.getUTCFullYear();
              const hours = String(date.getUTCHours()).padStart(2, '0');
              const minutes = String(date.getUTCMinutes()).padStart(2, '0');

              const formatted = `${day}.${month}.${year} at ${hours}:${minutes}`;
              return (
                <MDBox
                  key={entry?.id}
                  sx={{
                    borderRadius: '12px',
                    border: '1px solid #505577',
                    background: '#505577',
                    padding: '16px 24px',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    color: '#fff'
                  }}
                >
                  <MDTypography sx={{ color: '#fff' }}>{formatted}</MDTypography>
                  <MDTypography sx={{ color: '#fff' }}>{entry?.id}</MDTypography>
                  <MDButton color='' onClick={() => navigate(`/tournament/leaderboard/${entry?.id}`)}>
                    View entries
                  </MDButton>
                </MDBox>
              );
            })}
        </MDBox>
      </DashboardLayout> */}
    </>
  );
}

export default Tournament;
